// extracted by mini-css-extract-plugin
module.exports = {"Popover":"Popover_Popover__1z5VW","title":"Popover_title__2K-Qq","arrow":"Popover_arrow__3xVXn","inner":"Popover_inner__2ewTb"};